"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import { LitElement, html } from "lit";
import { customElement, property, state, query } from "lit/decorators.js";
import { hideSupportChat } from "../../hideSupportChat";
import { STCComponentMixin } from "../../common/mixins/stc_component_mixin";
export let PreviewKnowledgeBot = class extends STCComponentMixin(LitElement) {
  constructor() {
    super(...arguments);
    this.chatbotName = "";
    this.websocketUrl = "";
    this.navAiToken = "";
    this.productImageUrl = "";
    this.legalNotice = "";
    this.greetingMessage = "";
    this.botType = "";
    this.productID = "";
    this.isDrawerOpen = false;
  }
  handlePreviewClick() {
    this.isDrawerOpen = true;
  }
  handleClose() {
    this.isDrawerOpen = false;
  }
  updated(changedProperties) {
    if (changedProperties.has("isDrawerOpen") && this.isDrawerOpen) {
      if (this.drawer instanceof HTMLElement) {
        hideSupportChat(this.drawer);
      }
    }
  }
  renderDrawer() {
    if (!this.isDrawerOpen) return "";
    const prompts = [
      { html: this.legalNotice },
      { html: this.greetingMessage }
    ];
    return html`
      <hi-drawer
        id="preview_bot_drawer"
        @close-ended=${this.handleClose}
        opened
      >
        <eab-nav-knowledge-bot
          id="chat"
          heading="Chat with ${this.chatbotName}"
          placeholder="Ask a question"
          image=${this.productImageUrl}
          .prompts=${prompts}
          uri="${this.websocketUrl}${this.productID}?ctm_token=${this.navAiToken}"
        >
        </eab-nav-knowledge-bot>
      </hi-drawer>
    `;
  }
  render() {
    return html`
      <hi-button
        id="previewBot"
        class="mbm"
        aesthetic="secondary"
        @trigger-ended=${this.handlePreviewClick}
      >
        Preview ${this.botType}
      </hi-button>

      ${this.renderDrawer()}
    `;
  }
};
__decorateClass([
  property({ type: String })
], PreviewKnowledgeBot.prototype, "chatbotName", 2);
__decorateClass([
  property({ type: String })
], PreviewKnowledgeBot.prototype, "websocketUrl", 2);
__decorateClass([
  property({ type: String })
], PreviewKnowledgeBot.prototype, "navAiToken", 2);
__decorateClass([
  property({ type: String })
], PreviewKnowledgeBot.prototype, "productImageUrl", 2);
__decorateClass([
  property({ type: String })
], PreviewKnowledgeBot.prototype, "legalNotice", 2);
__decorateClass([
  property({ type: String })
], PreviewKnowledgeBot.prototype, "greetingMessage", 2);
__decorateClass([
  property({ type: String })
], PreviewKnowledgeBot.prototype, "botType", 2);
__decorateClass([
  property({ type: String })
], PreviewKnowledgeBot.prototype, "productID", 2);
__decorateClass([
  state()
], PreviewKnowledgeBot.prototype, "isDrawerOpen", 2);
__decorateClass([
  query("#preview_bot_drawer")
], PreviewKnowledgeBot.prototype, "drawer", 2);
__decorateClass([
  query("eab-nav-knowledge-bot")
], PreviewKnowledgeBot.prototype, "knowledgeBot", 2);
PreviewKnowledgeBot = __decorateClass([
  customElement("stc-preview-knowledge-bot")
], PreviewKnowledgeBot);
